"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUsersBannedFromCommunityResponseToJSON = exports.GetUsersBannedFromCommunityResponseFromJSONTyped = exports.GetUsersBannedFromCommunityResponseFromJSON = void 0;
var _1 = require("./");
function GetUsersBannedFromCommunityResponseFromJSON(json) {
    return GetUsersBannedFromCommunityResponseFromJSONTyped(json, false);
}
exports.GetUsersBannedFromCommunityResponseFromJSON = GetUsersBannedFromCommunityResponseFromJSON;
function GetUsersBannedFromCommunityResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bannedUsers': (json['bannedUsers'].map(_1.BannedUserFromJSON)),
    };
}
exports.GetUsersBannedFromCommunityResponseFromJSONTyped = GetUsersBannedFromCommunityResponseFromJSONTyped;
function GetUsersBannedFromCommunityResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bannedUsers': (value.bannedUsers.map(_1.BannedUserToJSON)),
    };
}
exports.GetUsersBannedFromCommunityResponseToJSON = GetUsersBannedFromCommunityResponseToJSON;
